// @flow

import * as React from 'react';
import ReactAI from 'react-appinsights';

type Props = {
    text: string,
    smallText?: string,
    extraClass?: string,
    id?: string,
    headerLevel: number
};

class CalculationSectionHeader extends React.Component<Props> {

    render() {
        
        let classes = "calculation-section-header input-section-header";
        if(this.props.extraClass)
            classes = classes + " " + this.props.extraClass;
        
        let idProp = {};
        if(this.props.id)
            idProp.id = this.props.id;
        const headerLevel = this.props.headerLevel || 2;
        
        return (headerLevel === 2 ?
            (<h2 className={classes} { ...idProp } >{this.props.text}{this.props.smallText && <small><br/>{this.props.smallText}</small>}</h2>)
            : (<h3 className={classes} { ...idProp } >{this.props.text}{this.props.smallText && <small><br/>{this.props.smallText}</small>}</h3>)
        );

    }

}

export default ReactAI.withTracking(CalculationSectionHeader); 


// WEBPACK FOOTER //
// ./src/components/CalculationSectionHeader.js